import React, { useEffect, useState } from "react";
import InputComponent from "../../components/Input";
import ButtonComponent from "../../components/Button";
import SelectDropdown from "../../components/SelectDropdown";
import { MdEmail } from "react-icons/md";
import { RiEBike2Fill } from "react-icons/ri";
import { FaLocationDot } from "react-icons/fa6";
import { IoDocumentText } from "react-icons/io5";
import { RiAdminFill } from "react-icons/ri";
import { BsFillTelephoneFill } from "react-icons/bs";
import { FaUser } from "react-icons/fa";
import { FaImage } from "react-icons/fa6";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import {
  onAddAdmin,
  onAddDriver,
  onAddVendor,
} from "../../store/actions/user-action";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import networkInstance from "../../services/api";
import toastMessage from "../../toast";
import axios from "axios";

const AddRole = () => {
  const userRole = useSelector(
    (state) => state.userDetails?.userInfo?.userResponse?.role
  );

  const [dropdownOptions, setDropdownOptions] = useState([]);
  useEffect(() => {
    if (userRole === "superAdmin") {
      setDropdownOptions([{ value: "admin", label: "Admin" }]);
    } else if (userRole === "admin") {
      setDropdownOptions([
        { value: "vendor", label: "Vendor" },
        { value: "driver", label: "Driver" },
      ]);
    }
  }, [userRole]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Full Name is required"),
    password: Yup.string()
      .required("Password is required")
      .min(8, "Password must be at least 8 characters"),
    avatar: Yup.string().required("Photo is required"),
    address: Yup.string().required("Address is required"),
    identity_proof_document_number: Yup.string().required(
      "Document Number is required"
    ),
    identity_proof_document_type: Yup.string().required(
      "Document Type is required"
    ),
    phoneNumber: Yup.string()
      .matches(/^[0-9]{10}$/, "Phone number is not valid")
      .required("Phone is required"),
    role: Yup.string().required("Role is required"),
    pin_code: Yup.string().required("Pin Code is required"),
    city: Yup.string().required("City is required"),

    // Conditional validation for vehicle_no (only required for drivers)
    vehicle_no: Yup.string().when("role", {
      is: "driver",
      then: (schema) => schema.required("Vehicle No is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    // Conditional validation for police_verification (only required for drivers)
    police_verification: Yup.string().when("role", {
      is: "driver",
      then: (schema) => schema.required("Police Verification is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    // Conditional validation for shop_name (only required for vendors)
    shop_name: Yup.string().when("role", {
      is: "vendor",
      then: (schema) => schema.required("Shop Name is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    // Latitude and longitude conditions
    lat: Yup.number().when("role", {
      is: (role) => role === "vendor" || role === "driver",
      then: (schema) => schema.required("Latitude is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    lng: Yup.number().when("role", {
      is: (role) => role === "vendor" || role === "driver",
      then: (schema) => schema.required("Longitude is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  });

  const formik = useFormik({
    initialValues: {
      phoneNumber: "",
      name: "",
      password: "",
      address: "",
      identity_proof_document_number: "",
      identity_proof_document_type: "Aadhaar",
      avatar: "",
      vehicle_no: "",
      lat: "",
      lng: "",
      email: "",
      pin_code: "",
      city: "",
      role:
        userRole === "superAdmin"
          ? "admin"
          : userRole === "admin"
          ? "vendor"
          : "",
      shop_name: "",
      police_verification: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values, formik) => {
      let response = "";

      if (values.role == "admin") {
        response = dispatch(onAddAdmin(values, formik));
      }
      if (values.role == "vendor") {
        values = transformPayloadforLocation(values);
        dispatch(onAddVendor(values, formik));
      }
      if (values.role == "driver") {
        values = transformPayloadforLocation(values);
        dispatch(onAddDriver(values, formik));
      }
    },
  });

  function transformPayloadforLocation(rawPayload) {
    const { lat, lng, ...otherDetails } = rawPayload;
    return {
      ...otherDetails,
      location: {
        lat,
        lng,
      },
    };
  }

  async function handleFileUpload(file) {
    try {
      const formData = new FormData();
      formData.append("images", file);

      const response = await networkInstance.post(
        `image-upload?folderName=test-folder&memberId=672273b8f92efd522631c26b `,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            accept: "/",
            "image-upload-api-header": "3CAQ9Hdv7gEPqCNx7aVOpvoX",
          },
        }
      );
      console.log(response);

      // if (response.ok) {
      //   const { url } = await response.json();
      //   formik.setFieldValue("avatar", url);
      // } else {
      //   toastMessage("error","Something went wrong.")
      // }
    } catch (error) {
      // toastMessage("error", error.message);
      console.error("Error during the request:", error);
      if (error.response) {
        // Server responded with a status code outside of 2xx range
        console.log("Response data:", error.response.data);
        console.log("Response status:", error.response.status);
        console.log("Response headers:", error.response.headers);
      } else if (error.request) {
        // No response was received from the server
        console.log("Request data:", error.request);
      } else {
        // Something else happened
        console.log("Error message:", error.message);
      }
    }
  }

  useEffect(() => {
    if (formik.values.role !== "driver") {
      formik.setFieldValue("vehicle_no", "");
    }
    if (formik.values.role !== "vendor") {
      formik.setFieldValue("shop_name", "");
    }
  }, [formik.values.role, formik.setFieldValue]);

  const isAdmin = formik.values.role === "admin";

  return (
    <div className="p-[25px] rounded-md border-[solid] border bg-white">
      <h3 className="font-medium">Add New Role</h3>
      <p className="text-sm text-[#595858] mt-2">
        In publishing and graphic design, Lorem ipsum is a placeholder text
        commonly used to demonstrate the visual form of a document or a typeface
        without relying on meaningful content.{" "}
      </p>
      {/* From start from here */}
      <form className="mt-5" onSubmit={formik.handleSubmit}>
        <div class="flex space-x-4">
          <div class="flex-1">
            <label
              for="name"
              class="block text-sm font-medium leading-6 text-gray-900"
            >
              Full Name
            </label>
            <InputComponent
              type="text"
              name={"name"}
              placeholder="Enter full name"
              icon={<FaUser />}
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.name && formik.errors.name}
            />
            {formik.touched.name && formik.errors.name ? (
              <div className="text-red-500 text-sm font-medium ">
                {formik.errors.name}
              </div>
            ) : null}
          </div>

          <div class="flex-1">
            <label
              for="number"
              class="block text-sm font-medium leading-6 text-gray-900"
            >
              Phone
            </label>
            <InputComponent
              type="text"
              name={"phoneNumber"}
              placeholder="Enter Phone Number"
              icon={<BsFillTelephoneFill />}
              value={formik.values.phoneNumber}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.phoneNumber && formik.errors.phoneNumber}
            />
            {formik.touched.phoneNumber && formik.errors.phoneNumber ? (
              <div className="text-red-500 text-sm font-medium">
                {formik.errors.phoneNumber}
              </div>
            ) : null}
          </div>
        </div>

        <div class="flex space-x-4 mt-4">
          <div class="flex-1">
            <label
              for="role"
              class="block text-sm font-medium leading-6 text-gray-900 mt-2"
            >
              Select Role
            </label>
            <SelectDropdown
              name="role"
              icon={<RiAdminFill />}
              value={formik.values.role}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              options={dropdownOptions}
              error={formik.touched.role && formik.errors.role}
            />
            {formik.touched.role && formik.errors.role ? (
              <div className="text-red-500 text-sm font-medium ">
                {formik.errors.role}
              </div>
            ) : null}
          </div>

          <div class="flex-1">
            <label
              for="number"
              class="block text-sm font-medium leading-6 text-gray-900"
            >
              Password
            </label>
            <InputComponent
              type="password"
              name={"password"}
              placeholder="Enter your password"
              icon={<BsFillTelephoneFill />}
              value={formik.values.password}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.password && formik.errors.password}
            />
            {formik.touched.password && formik.errors.password ? (
              <div className="text-red-500 text-sm font-medium">
                {formik.errors.password}
              </div>
            ) : null}
          </div>
        </div>

        <div class="flex space-x-4 mt-4">
          <div class="flex-1">
            <label
              for="avatar"
              class="block text-sm font-medium leading-6 text-gray-900"
            >
              Add Avatar Photo
            </label>
            <InputComponent
              type="input"
              name={"avatar"}
              placeholder="Upload Photo"
              icon={<FaImage />}
              value={formik.values.avatar}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.avatar && formik.errors.avatar}
            />
            {formik.touched.avatar && formik.errors.avatar ? (
              <div className="text-red-500 text-sm font-medium ">
                {formik.errors.avatar}
              </div>
            ) : null}
          </div>

          {isAdmin != "vendor" && (
            <div class="flex-1">
              <label
                for="number"
                class="block text-sm font-medium leading-6 text-gray-900"
              >
                Address
              </label>
              <InputComponent
                type="text"
                name={"address"}
                placeholder="Enter Address"
                icon={<BsFillTelephoneFill />}
                value={formik.values.address}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.address && formik.errors.address}
              />
              {formik.touched.address && formik.errors.address ? (
                <div className="text-red-500 text-sm font-medium">
                  {formik.errors.address}
                </div>
              ) : null}
            </div>
          )}
        </div>
        {isAdmin != "vendor" && (
          <>
            {formik.values.role == "vendor" && (
              <div class="flex space-x-4 mt-4">
                <div class="flex-1">
                  <label
                    for="number"
                    class="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Shop Name
                  </label>
                  <InputComponent
                    type="text"
                    name={"shop_name"}
                    placeholder="Enter Shop Name"
                    icon={<BsFillTelephoneFill />}
                    value={formik.values.shop_name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.shop_name && formik.errors.shop_name}
                  />
                  {formik.touched.shop_name && formik.errors.shop_name ? (
                    <div className="text-red-500 text-sm font-medium">
                      {formik.errors.shop_name}
                    </div>
                  ) : null}
                </div>
              </div>
            )}
          </>
        )}
        <div class="flex space-x-4 mt-4">
          {isAdmin != "vendor" && (
            <>
              {" "}
              {formik.values.role == "driver" && (
                <div class="flex-1">
                  <label
                    for="vehicle_no"
                    class="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Police Verification
                  </label>
                  <InputComponent
                    type="text"
                    name={"police_verification"}
                    placeholder="Police Verification"
                    icon={<RiEBike2Fill />}
                    value={formik.values.police_verification}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.police_verification &&
                      formik.errors.police_verification
                    }
                  />
                  {formik.touched.police_verification &&
                  formik.errors.police_verification ? (
                    <div className="text-red-500 text-sm font-medium ">
                      {formik.errors.police_verification}
                    </div>
                  ) : null}
                </div>
              )}
              {formik.values.role == "driver" && (
                <div class="flex-1">
                  <label
                    for="vehicle_no"
                    class="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Vehicle No
                  </label>
                  <InputComponent
                    type="text"
                    name={"vehicle_no"}
                    placeholder="Enter Vecicle No"
                    icon={<RiEBike2Fill />}
                    value={formik.values.vehicle_no}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.vehicle_no && formik.errors.vehicle_no
                    }
                  />
                  {formik.touched.vehicle_no && formik.errors.vehicle_no ? (
                    <div className="text-red-500 text-sm font-medium ">
                      {formik.errors.vehicle_no}
                    </div>
                  ) : null}
                </div>
              )}
            </>
          )}
        </div>

        <div class="flex space-x-4 mt-4">
          <div class="flex-1">
            <label
              for="number"
              class="block text-sm font-medium leading-6 text-gray-900"
            >
              pin code
            </label>
            <InputComponent
              type="text"
              name={"pin_code"}
              placeholder="Enter Pin Code"
              icon={<BsFillTelephoneFill />}
              value={formik.values.pin_code}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.pin_code && formik.errors.pin_code}
            />
            {formik.touched.pin_code && formik.errors.pin_code ? (
              <div className="text-red-500 text-sm font-medium">
                {formik.errors.pin_code}
              </div>
            ) : null}
          </div>

          <div class="flex-1">
            <label
              for="number"
              class="block text-sm font-medium leading-6 text-gray-900"
            >
              city
            </label>
            <InputComponent
              type="text"
              name={"city"}
              placeholder="Enter Your City"
              icon={<BsFillTelephoneFill />}
              value={formik.values.city}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.city && formik.errors.city}
            />
            {formik.touched.city && formik.errors.city ? (
              <div className="text-red-500 text-sm font-medium">
                {formik.errors.city}
              </div>
            ) : null}
          </div>
        </div>

        {!isAdmin && (
          <div class="flex space-x-4 mt-4">
            <div class="flex-1">
              <label
                for="lat"
                class="block text-sm font-medium leading-6 text-gray-900"
              >
                Add Latitude
              </label>
              <InputComponent
                type="text"
                name={"lat"}
                placeholder="Enter Latitude"
                icon={<FaLocationDot />}
                value={formik.values.lat}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched?.lat && formik.errors?.lat}
              />
              {formik.touched?.lat && formik.errors?.lat ? (
                <div className="text-red-500 text-sm font-medium">
                  {formik.errors.lat}
                </div>
              ) : null}
            </div>

            <div class="flex-1">
              <label
                for="lng"
                class="block text-sm font-medium leading-6 text-gray-900"
              >
                Add Longitude
              </label>
              <InputComponent
                type="string"
                name={"lng"}
                placeholder="Enter Longitude"
                icon={<FaLocationDot />}
                value={formik.values.lag}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched?.lng && formik.errors?.lng}
              />
              {formik.touched?.lng && formik.errors?.lng ? (
                <div className="text-red-500 text-sm font-medium">
                  {formik.errors.lng}
                </div>
              ) : null}
            </div>
          </div>
        )}

        <div class="flex space-x-4 mt-4">
          <div class="flex-1">
            <label
              for="identity_proof_document_type"
              class="block text-sm font-medium leading-6 text-gray-900 mb-2"
            >
              Identity Proof Document Type
            </label>
            <SelectDropdown
              name="identity_proof_document_type"
              icon={<IoDocumentText />}
              options={[
                { value: "Aadhaar", label: "Aadhaar" },
                { value: "Passport", label: "Passport" },
                { value: "Driving License", label: "Driving License" },
                { value: "PAN Card", label: "PAN Card" },
                { value: "Voter Id", label: "Voter Id" },
                { value: "Other", label: "Other" },
              ]}
              value={formik.values.identity_proof_document_type}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched?.identity_proof_document_type &&
                formik.errors?.identity_proof_document_type
              }
            />
            {formik.touched?.identity_proof_document_type &&
            formik.errors?.identity_proof_document_type ? (
              <div className="text-red-500 text-sm font-medium">
                {formik.errors.identity_proof_document_type}
              </div>
            ) : null}
          </div>
          <div class="flex-1">
            <label
              for="identity_proof_document_number"
              class="block text-sm font-medium leading-6 text-gray-900"
            >
              Identity Proof Document Number
            </label>
            <InputComponent
              type="text"
              name={"identity_proof_document_number"}
              placeholder="Enter Document Number"
              icon={<IoDocumentText />}
              value={formik.values.identity_proof_document_number}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched?.identity_proof_document_number &&
                formik.errors?.identity_proof_document_number
              }
            />
            {formik.touched?.identity_proof_document_number &&
            formik.errors?.identity_proof_document_number ? (
              <div className="text-red-500 text-sm font-medium">
                {formik.errors.identity_proof_document_number}
              </div>
            ) : null}
          </div>
        </div>

        <div className="mt-5 text-right rounded">
          <ButtonComponent text="Add New Role" />
        </div>
      </form>
    </div>
  );
};

export default React.memo(AddRole);
